var video_viewer_default = {
  "video_player": "lAUMt",
  "videoOverlay": "roPr6",
  "video_container": "lh1bF"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
